import script from "./MypageAllocation.vue?vue&type=script&setup=true&lang=ts"
export * from "./MypageAllocation.vue?vue&type=script&setup=true&lang=ts"

import "./mypage.css?vue&type=style&index=0&id=0481e770&scoped=true&lang=css"
import "./MypageAllocation.vue?vue&type=style&index=1&id=0481e770&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0481e770"]])

export default __exports__